class NoodCart extends HTMLElement {
  constructor() {
    super()

    this.root = window.Shopify.routes.root || '/'

    this.state = 'idle'

    this.$cartOpen = document.querySelectorAll('[data-cart-open]')
    this.$cartClose = this.querySelector('[data-cart-close]')
    this.$cartOverlay = this.parentElement.querySelector('[data-cart-overlay]')
    this.$cartScrollContainer = this.querySelector('[data-cart-scroll-container]')
    this.$cartTopBar = this.querySelector('[data-cart-top-bar]')

    this.$cartOpen.forEach((el) => el.addEventListener('click', this.open.bind(this)))
    this.$cartClose.addEventListener('click', this.close.bind(this))
    this.$cartOverlay.addEventListener('click', this.close.bind(this))

    this.initScrollTopShadow()
    this.initCheckoutSpinner()

    this.escapeHandler = (e) => {
      if (e.key === 'Escape') this.close()
    }

    // if (
    //   this.getCookie('getCart') != '' &&
    //   this.getCookie('getCart') == 'Yes' &&
    //   window.location.href.indexOf('cart') == -1 &&
    //   window.location.href.indexOf('pages') == -1 &&
    //   window.location.href.indexOf('account') == -1
    // ) {
    //   this.open({ getCart: false })
    // }

    const search = new URLSearchParams(window.location.search)
    const cartOpen = search.get('cartOpen')
    if (cartOpen !== null) this.open({ getCart: false })
  }

  // getCookie(cname) {
  //   var name = cname + '='
  //   var decodedCookie = document.cookie
  //   var ca = decodedCookie.split(';')
  //   for (var i = 0; i < ca.length; i++) {
  //     var c = ca[i]
  //     while (c.charAt(0) == ' ') {
  //       c = c.substring(1)
  //     }
  //     if (c.indexOf(name) == 0) {
  //       return c.substring(name.length, c.length)
  //     }
  //   }
  //   return ''
  // }

  // setCookie(cname, cvalue, exdays) {
  //   var d = new Date()
  //   d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000)
  //   var expires = 'expires=' + d.toUTCString()
  //   document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/'
  // }

  async open(opts = {}) {
    if (opts.getCart !== false) await this.getCart()
    this.classList.remove('tw-opacity-0', 'tw-translate-x-full', 'tw-pointer-events-none')
    this.classList.add('tw-translate-x-0')
    this.$cartOverlay.classList.remove('tw-opacity-0', 'tw-pointer-events-none')
    document.body.classList.add('!tw-overflow-hidden')
    this.classList.remove('tw-invisible')
    trapFocus(this)

    document.addEventListener('keydown', this.escapeHandler)
  }

  close() {
    this.$cartOverlay.classList.add('tw-opacity-0', 'tw-pointer-events-none')
    this.classList.remove('tw-translate-x-0')
    this.classList.add('tw-opacity-0', 'tw-translate-x-full', 'tw-pointer-events-none')
    document.body.classList.remove('!tw-overflow-hidden', 'js-drawer-open')
    document.documentElement.classList.remove('js-drawer-open')
    this.classList.add('tw-invisible')
    removeTrapFocus(this)
    document.removeEventListener('keydown', this.escapeHandler)
    // if (this.getCookie('getCart') != '' && this.getCookie('getCart') == 'Yes') {
    //   this.setCookie('getCart', '')
    // }
    this.$cartOpen[0].focus()
  }

  setState(state) {
    this.state = state
    this.dispatchEvent(new CustomEvent('state-change', { detail: state }))
  }

  initCheckoutSpinner() {
    if (this.$checkout) return
    this.$checkout = this.querySelector('[data-checkout]')
    if (!this.$checkout) return
    this.$checkout.addEventListener('click', () => {
      const $spinner = this.$checkout.querySelector('svg')
      const $span = this.$checkout.querySelector('span')

      $span.classList.add('tw-invisible')
      $spinner.classList.remove('tw-hidden')

      setTimeout(() => {
        $span.classList.remove('tw-invisible')
        $spinner.classList.add('tw-hidden')
      }, 5000)
    })
  }

  async getCart() {
    // Uses the section rendering API to get a new cart
    if (this.state !== 'idle') return
    try {
      this.state = 'loading'
      const res = await fetch(`${this.root}?section_id=v2-cart&skipCache`)
      const htmlText = await res.text()

      try {
        this.update(htmlText)
      } catch (error) {
        console.error('Error parsing cart HTML', error)
      }
    } catch (error) {
      console.error('Error getting cart', error)
    } finally {
      this.state = 'idle'
    }
  }

  async changeCart(line, quantity) {
    if (this.state !== 'idle') return
    try {
      this.state = 'loading'
      const res = await fetch(`${this.root}cart/change?skipCache`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          line,
          quantity,
          sections: 'v2-cart',
        }),
      })
      const data = await res.json()
      try {
        this.update(data.sections['v2-cart'])
      } catch (error) {
        console.error('Error parsing cart HTML', error)
      }
    } catch (error) {
      console.error('Error changing cart', error)
    } finally {
      this.state = 'idle'
    }
  }

  async addToCart(opts = {}) {
    if (!opts.id) return

    if (this.state !== 'idle') return
    try {
      this.state = 'loading'
      const res = await fetch(`${this.root}cart/add?skipCache`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          ...opts,
          sections: 'v2-cart',
        }),
      })
      const data = await res.json()
      try {
        this.update(data.sections['v2-cart'])
      } catch (error) {
        console.error('Error parsing cart HTML', error)
      }
    } catch (error) {
      console.error('Error adding to cart', error)
    } finally {
      this.state = 'idle'
    }
  }

  update(html) {
    const newCartHtml = new DOMParser().parseFromString(html, 'text/html')
    window.morphdom(this, newCartHtml.querySelector('nood-cart'), {
      childrenOnly: true,
    })

    const $cartItemCountSource = this.querySelector('[data-cart-item-count-source]')
    const cartItemCount = $cartItemCountSource.dataset.cartItemCountSource
    const $cartItemCounts = document.querySelectorAll('[data-cart-item-count]')
    $cartItemCounts.forEach((el) => {
      if (cartItemCount > 0) {
        el.childNodes[0].textContent = cartItemCount
        el.classList.remove('tw-invisible')
      } else {
        el.classList.add('tw-invisible')
      }
    })

    this.initCheckoutSpinner()

    this.querySelectorAll('cart-upsell, cart-item').forEach(($el) => {
      $el.init()
    })

    // Affirm Handling
    window.affirm?.jsReady(() => {
      const $affirmWrapper = this.querySelector('.affirm-wrapper')
      if ($affirmWrapper && window.affirm?.ui?.refresh) {
        const $affirmElement = $affirmWrapper.querySelector('.affirm-as-low-as')
        const observerCallback = (mutations, observer) => {
          mutations.forEach((mutation) => {
            if (mutation.type === 'childList') {
              const $affirmLink = $affirmWrapper.querySelector('.affirm-as-low-as a')
              const $affirmPriceElement = $affirmWrapper.querySelector('.affirm-ala-price')
              const $afirmModalTrigger = $affirmWrapper.querySelector('.affirm-modal-trigger')
              if (!$affirmLink || !$affirmPriceElement || !$afirmModalTrigger) return

              observer.disconnect()

              const $affirmAfterText = $affirmWrapper.querySelector('.affirm-after-text')
              if (!$affirmWrapper.hasAttribute('data-has-subscription')) {
                $affirmAfterText.classList.remove('tw-text-orange')
                $affirmAfterText.classList.remove('tw-font-bold')
                $affirmAfterText.classList.add('tw-text-gray-2')
              }
              $affirmLink.before($affirmAfterText)

              $afirmModalTrigger.classList.add('tw-text-orange', 'tw-underline')
            }
          })
        }
        const observer = new MutationObserver(observerCallback)
        observer.observe($affirmElement, { childList: true })

        const affirmElements = document.querySelectorAll('.affirm-as-low-as')
        const cartAffirmElement = $affirmElement

        // Remove the class from all elements except the one in the cart
        affirmElements.forEach((element) => {
          // Skip the element if it's the one in the cart
          if (element !== cartAffirmElement && element.closest('nood-cart') !== this.closest('nood-cart')) {
            // Remove the class
            element.classList.remove('affirm-as-low-as')
          }
        })

        window.affirm.ui.refresh()

        // Add the affirm-as-low-as class back to elements after refresh
        setTimeout(() => {
          affirmElements.forEach((element) => {
            // Skip the element if it's the one in the cart
            if (element !== cartAffirmElement && element.closest('nood-cart') !== this.closest('nood-cart')) {
              element.classList.add('affirm-as-low-as')
            }
          })
        }, 500) // Wait for affirm UI refresh to complete
      }
    })

    // Extend - Dispatch event when cart changes to update Extend
    window.dispatchEvent(new Event('refreshAjaxSideCart'))
    // Extend - End code
  }

  initScrollTopShadow() {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          this.$cartTopBar.classList.remove('tw-shadow')
        } else {
          this.$cartTopBar.classList.add('tw-shadow')
        }
      },
      { threshold: 1.0 }
    )

    // Create and observe a sentinel element at the top of the scroll container
    const sentinel = this.querySelector('[data-sentinel]')
    observer.observe(sentinel)
  }
}
customElements.define('nood-cart', NoodCart)

class CartItem extends HTMLElement {
  constructor() {
    super()

    this.init()
  }

  init() {
    this.$cart = this.closest('nood-cart')

    this.state = 'idle'

    this.$decrease = this.querySelector('[data-decrease]')
    this.$increase = this.querySelector('[data-increase]')
    this.$quantity = this.querySelector('[data-quantity]')
    this.$loading = this.querySelector('[data-loading]')

    this.$decrease.addEventListener('click', this.decreaseQuantity.bind(this))
    this.$increase.addEventListener('click', this.increaseQuantity.bind(this))
  }

  setState(state) {
    this.state = state
    if (state === 'loading') {
      this.$loading.classList.remove('!tw-hidden')
    } else {
      this.$loading.classList.add('!tw-hidden')
    }
  }

  decreaseQuantity() {
    const $quantity = this.querySelector('[data-quantity]')
    const currentQty = parseInt($quantity.textContent)
    if (currentQty > 0) {
      this.setState('loading')
      this.$cart.changeCart(this.dataset.line, currentQty - 1)
    }
  }

  increaseQuantity() {
    const $quantity = this.querySelector('[data-quantity]')
    const currentQty = parseInt($quantity.textContent)
    this.setState('loading')
    this.$cart.changeCart(this.dataset.line, currentQty + 1)
  }
}
customElements.define('cart-item', CartItem)

class CartUpsell extends HTMLElement {
  constructor() {
    super()

    this.init()
  }

  init() {
    this.$cart = this.closest('nood-cart')

    this.state = 'idle'
    this.$loading = this.querySelector('[data-loading]')

    this.$add = this.querySelector('[data-cart-upsell-add]')
    this.$add.addEventListener('click', this.add.bind(this))

    this.$primaryImage = this.querySelector('[data-primary-image]')
    this.$productLinks = this.querySelectorAll('[data-product-link]')
    this.$variantTitle = this.querySelector('[data-variant-title]')

    this.addEventListener('change', this.handleColorChange.bind(this))
  }

  handleColorChange(e) {
    const $swatch = e.target
    const variantId = $swatch.getAttribute('data-variant-id')
    if (variantId) {
      this.$primaryImage.classList.add('tw-opacity-0')
      const otherVariantImages = this.querySelectorAll(`[data-variant-image]:not([data-variant-image="${variantId}"])`)
      otherVariantImages.forEach((image) => {
        image.classList.add('tw-opacity-0')
      })

      const variantImage = this.querySelector(`[data-variant-image="${variantId}"]`)
      variantImage.classList.remove('tw-opacity-0')
    } else {
      const variantImages = this.querySelectorAll('[data-variant-image]')
      variantImages.forEach((image) => {
        image.classList.add('tw-opacity-0')
      })

      this.$primaryImage.classList.remove('tw-opacity-0')
    }

    this.$variantTitle.textContent = $swatch.value

    this.$add.dataset.variantId = variantId
  }

  setState(state) {
    this.state = state
    if (state === 'loading') {
      this.$loading.classList.remove('!tw-hidden')
    } else {
      this.$loading.classList.add('!tw-hidden')
    }
  }

  add() {
    this.setState('loading')
    this.$cart.addToCart({
      id: parseInt(this.$add.dataset.variantId),
      quantity: 1,
      ...(this.$add.dataset.sellingPlanId ? { selling_plan: parseInt(this.$add.dataset.sellingPlanId) } : {}),
    })
  }
}
customElements.define('cart-upsell', CartUpsell)
